import { useState } from "react";
import { Container } from "reactstrap";
import cn from "classnames";
import styles from "./styles.module.scss";
import SearchIcon from "@/assets/Search.svg";
import PodcastSection from "@/builder/PodcastSection";
import BlogSection from "@/builder/BlogSection";
import EventsSection from "@/builder/EventsSection";

import useBlogs from "@/hooks/useBlogs";
import usePodcast from "@/hooks/usePodcast";
import useEvent from "@/hooks/useEvent";

export const ResourcesPage = ({ title, subtitle, className }) => {
  const [search, setSearch] = useState("");

  const blogs = useBlogs() || [];
  const podcasts = usePodcast() || [];
  const events = useEvent() || [];

  const filter = (items) =>
    items.filter(
      (item) =>
        item.title?.toLowerCase().includes(search.toLowerCase()) ||
        item.description?.toLowerCase().includes(search.toLowerCase()),
    );

  const filteredBlogs = filter(blogs);
  const filteredEvents = filter(events);
  const filteredPodcasts = filter(podcasts);

  return (
    <section className={cn(styles.ResourcesPage, className)}>
      <Container className={styles.inner}>
        <div className={styles.searchBar}>
          <SearchIcon className={styles.icon} />
          <input
            type="text"
            placeholder="Search by keywords"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>

        <div className={styles.layout}>
          <div className={styles.menu}>
            <div className={styles.jumpLabel}>JUMP TO</div>
            <div className={styles.menuList}>
              <a href="#blogs" className={styles.menuItem}>
                Blogs
              </a>
              <a href="#events" className={styles.menuItem}>
                Events
              </a>
              <a href="#podcasts" className={styles.menuItem}>
                Podcasts
              </a>
            </div>
          </div>

          <div className={styles.main}>
            {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
            {title && <h2 className={styles.title}>{title}</h2>}

            {filteredBlogs.length > 0 && (
              <section id="blogs" className={styles.section}>
                <BlogSection items={filteredBlogs} />
              </section>
            )}

            {filteredEvents.length > 0 && (
              <section id="events" className={styles.section}>
                <EventsSection items={filteredEvents} />
              </section>
            )}

            {filteredPodcasts.length > 0 && (
              <section id="podcasts" className={styles.section}>
                <PodcastSection items={filteredPodcasts} />
              </section>
            )}

            {filteredBlogs.length + filteredEvents.length + filteredPodcasts.length === 0 && <p>No results found.</p>}
          </div>
        </div>
      </Container>
    </section>
  );
};

export default ResourcesPage;
